import fetch from '@/utils/fetch';
import { City } from './type';
import { message } from 'antd';
import { getCityList as getCityData } from '@/apis/commonApi';

const model = {
  state: {
    cityList: [],
    cacheKey: '0',
    messageDetail: null,
    cacheTime: -1,
    submitLoading: false,
  },
  reducers: {
    setState(state: any, partialState: any) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { NoticeManage, basic }, getState }: any) => ({
    async getCityList() {
      const data = getState().basic?.cityData || (await getCityData()) || [];
      const cityList = data?.map((province) => province.children || []).flat() || [];
      NoticeManage.setState({
        cityList,
      });
    },
    async saveMessage(params, history) {
      NoticeManage.setState({
        submitLoading: true,
      });
      const data = await fetch('/saasmerchant/web/merchantsmessage/save', {
        type: 'POST',
        useJson: true,
        params,
      });
      if (data) {
        message.success(`${params.messageId ? '编辑' : '创建'}成功`);
        history.push('/merchant/notice');
      } else {
        message.error(`${params.messageId ? '编辑' : '创建'}失败`);
      }
      NoticeManage.setState({
        submitLoading: false,
      });
    },
    async getMessageDetail(messageId) {
      const data = await fetch('/saasmerchant/web/merchantsmessage/detail', {
        type: 'POST',
        useJson: true,
        params: {
          messageId,
        },
      });
      if (data) {
        NoticeManage.setState({
          messageDetail: data,
        });
      }
    },
    setCacheKey(key: string) {
      NoticeManage.setState({
        cacheKey: key,
      });
    },
    setCacheTime(time: number) {
      NoticeManage.setState({
        cacheTime: time,
      });
    },
    resetDetail() {
      NoticeManage.setState({
        messageDetail: null,
      });
    },
  }),
};

export default model;
